import imageField from 'molecules/Image/config';

import type { Input } from '@builder.io/sdk';

const testimonialFields = [
  {
    name: 'backgroundColor',
    type: 'string',
    enum: ['blue', 'gray', 'teal', 'white', 'lightgray', 'ash', 'darkash', 'carbon', 'wgray80', 'greige'],
    defaultValue: 'white',
  },
  imageField('titleImage'),
  {
    name: 'content',
    type: 'richText',
  },
  {
    name: 'Cta',
    type: 'object',
    subFields: [
      {
        name: 'label',
        type: 'string',
      },
      {
        name: 'href',
        type: 'url',
      },
      {
        name: 'type',
        type: 'string',
        enum: ['arrow', 'button'],
        defaultValue: 'arrow',
      },
    ],
  },
  {
    name: 'disclaimer',
    type: 'string',
  },
  imageField('image'),
  {
    name: 'align',
    type: 'string',
    enum: ['left', 'right', 'split'],
    defaultValue: 'left',
  },
] as const satisfies DeepReadonly<Input[]>;

const testimonialConfig = {
  name: 'Testimonial',
  inputs: testimonialFields,
};

export type TestimonialProps = GenerateBuilder<typeof testimonialFields>;

export default testimonialConfig;
